import React from "react";
import Section from "../../Section";
import SecondaryTitle from "../../Titles/SecondaryTitle";
import Button from "../../Button";

const CTA = () => {
  return (
    <Section className='relative overflow-hidden py-24'>
      {/* Background Gradient */}
      <div className='absolute inset-0 bg-gradient-luxury z-0'></div>

      {/* Decorative Elements */}
      <div className='absolute top-10 right-10 w-64 h-64 bg-accent-gold/10 rounded-full blur-3xl'></div>
      <div className='absolute bottom-10 left-10 w-48 h-48 bg-accent-emerald/10 rounded-full blur-2xl'></div>

      {/* Content */}
      <div className='relative z-10 max-w-screen-xl mx-auto px-6 lg:px-16'>
        <div className='text-center space-y-8'>

          {/* Accent Text */}
          <span className='text-accent-gold text-sm uppercase font-semibold tracking-widest'>
            Ready for Your Transformation
          </span>

          {/* Main Heading */}
          <SecondaryTitle
            title='Book Your Appointment Today'
            className='text-text-light leading-tight'
            animation='fade-up'
          />

          {/* Divider */}
          <div className='h-1 w-16 bg-gradient-gold mx-auto rounded-full'></div>

          {/* Description */}
          <div className='max-w-2xl mx-auto'>
            <p className='paragraph text-text-light/80 text-sm sm:text-base md:text-lg lg:text-xl'>
              Experience premium hair care and beauty treatments at Ancy Friz. Our expert team is ready to help you discover your best self. Contact us now and schedule your appointment!
            </p>
          </div>

          {/* CTA Buttons */}
          <div className='flex flex-col sm:flex-row gap-6 justify-center items-center pt-6'>
            <Button
              title='Call Now'
              link='tel:+38762741146'
              className='btn-primary px-10 py-4 text-lg'
              variant='primary'
            />
            <Button
              title='Send Message'
              link='/contact'
              className='btn-secondary px-10 py-4 text-lg'
              variant='secondary'
            />
          </div>

          {/* Trust Badge */}
          <div className='pt-12 border-t border-accent-gold/20'>
            <p className='text-text-light/70 text-sm'>
              ✓ Professional Team  •  ✓ Premium Products  •  ✓ 100% Satisfaction
            </p>
          </div>
        </div>
      </div>
    </Section>
  );
};

export default CTA;
